import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableReCaptchaForGiftCard',
  initialState: false,
  reducers: {
    setEnableReCaptchaForGiftCard(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableReCaptchaForGiftCard } = slice.actions;

export default slice.reducer;
